import {SEARCH_SELECT_TAGS_TYPE} from "../../constants/commons";
import {setBlogTags, tryAddNewTagAndUpdateInBlog} from "../../redux/slices/manageBlogSlice";
import {FocusedSearchSelect} from "./FocusedSelect";
import {useDispatch, useSelector} from "react-redux";
import {BLOG_TAG_MIN_LENGTH} from "../../pages/blogs/constants";
import {toast} from "react-toastify";


export const TagsSearchSelect = () => {

  const addingTags = useSelector((state => state.manageBlogs.create.tag.loading));

  const dispatch = useDispatch()

  const onTagCreate = (tag)=>{
    if(tag.length <  BLOG_TAG_MIN_LENGTH){
      toast.error(`Tags must be at least ${BLOG_TAG_MIN_LENGTH} characters long.`)
    }else{
      dispatch(tryAddNewTagAndUpdateInBlog({title: tag}))
    }


  }



  return (
    <FocusedSearchSelect isDisabled={addingTags} placeholder={addingTags ? "Adding, please wait...":"Search for tags"}  creatable={true} onCreateOption={onTagCreate} value=""
                         formatCreateLabel={(text)=> `Create and Add "${text}"`}
                         label="Add Blog Tags" type={SEARCH_SELECT_TAGS_TYPE}
                         onChange={(tag) => dispatch(setBlogTags({tag}))} isRequired={false}/>


  );


};




